import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

async function getDefaultDepartmentOwners(params) {
  const response = await privateClient.get('/defaultResources', {
    params: { siteId: params.siteId },
  });
  return response.data;
}

export function getDefaultResourceOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getDefaultDepartmentOwners', params],
    queryFn: () => getDefaultDepartmentOwners(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

async function getDepartmentWorkers(params) {
  const response = await privateClient.get(
    `/departmentWorkers?departmentId=${params.departmentId}&siteId=${params.siteId}`
  );
  return response.data;
}

export function createGetDepartmentWorkerOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getDepartmentWorkers', params],
    queryFn: () => getDepartmentWorkers(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function updateDepartmentWorker(params) {
  const response = await privateClient.put('/UpdateResourceModification', {
    ...params,
  });
  return response.data;
}

async function getDepartmentDefaultLables(params) {
  const response = await privateClient.get(
    `/departmentDefaultLabels?departmentName=${params.departmentName}&siteId=${params.siteId}`
  );
  return response.data;
}

export function createGetDepartmentDefaultLabelsOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getDepartmentDefaultLabels', params],
    queryFn: () => getDepartmentDefaultLables(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function setExecutor(params) {
  const response = await privateClient.post('/setExecutor', {
    ...params,
  });
  return response.data;
}

async function getScDepartments(params) {
  const response = await privateClient.post('/SCDepartments', {
    ...params,
  });
  return response.data;
}

export function createGetScDepartmentOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getScDepartments', params],
    queryFn: () => getScDepartments(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getScDepartmentsPopup(params) {
  const response = await privateClient.post('/SCDepartmentsPOPUP', {
    ...params,
  });
  return response.data;
}

export function createGetScDepartmentsPopupOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getScDepartmentsPopup', params],
    queryFn: () => getScDepartmentsPopup(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function addDepartments(params) {
  const response = await privateClient.post('/addDepartments', {
    ...params,
  });
  return response.data;
}
